// en, de, fr, pt
export default {
  en: {
    Dashboard: 'Dashboard',
    Warehouse: 'Warehouse',
    Sales: 'Sales',
    Purchases: 'Purchases',
    Products: 'Products',
    Brands: 'Brands',
    Categories: 'Categories',
    Clients: 'Clients',
    Settings: 'Settings',
    Users: 'Users',
    Notifications: 'Notifications',
    Content: 'Content',
    Orders: 'Orders',
    General: 'General',
    Posts: 'Posts'
  }
}
